<style scoped>
.box{
    min-height: 100vh;
    background: #fff;
    padding-top: .98rem;
}
.contentBox{
    padding: 0 .3rem;
}
.title{
    margin: .4rem 0 .3rem;
    font-size: .36rem;
    color: #333;
}
.title span{
    font-size: .258rem;
    color: #959595;
}
.flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.typeList{
    width: 1.56rem;
    height: .76rem;
    background: #F4F4F4;
    font-size: .28rem;
    color: #333;
    text-align: center;
    line-height: .76rem;
    border-radius: .08rem;
}

.typeList.active{
    color: #00C59F;
    border: .01rem solid #00C59F;
}

.tabBox{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.tabItem{
    height: .7rem;
    border: .01rem solid #B5B5B5;
    border-radius: .35rem;
    padding: 0 .3rem;
    margin-right: .2rem;
    line-height: .7rem;
    box-sizing: border-box;
    margin-bottom: .2rem;
}

.tabItem.active{
    color: #00C59F;
    border: .01rem solid #00C59F;
}

.inputBox{
    display: flex;
    justify-content: center;
}
input{
    width: 2.3rem;
    border: none;
    padding-bottom: .1rem;
    border-bottom: .01rem solid #B2D5CE;
    font-size: 1rem;
    color: #333;
    text-align: center;
    font-weight: bold;
}
.btn{
    width:2.4rem;
    height:.8rem;
    background:#00C59F;
    border-radius: .1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem auto;
    font-size: .3rem;
    color: #fff;
}
</style>
<template>
    <div class="box" style="padding-top: .98rem">
        <topbar text="咨询记录"></topbar>
        <div class="contentBox">
            <div class="title">症状程度</div>
            <div class="flex">
                <div class="typeList" @click="change(item.status)" :class="{active:tagLevel==item.status}" v-for="(item,index) in typeList" :key="index">{{item.name}}</div>
            </div>
        </div>
        <div class="contentBox">
            <div class="title">评分标准 <span>总分100分</span></div>
            <div class="inputBox">
                <input type="number" v-model="score" name="" id="">
            </div>
        </div>
        <div class="contentBox">
            <div class="title">用户标签 <span>(可多选)</span></div>
            <div class="tabBox">
                <div class="tabItem" @click="setTagText(index)" :class="{active:item.status}" v-for="(item,index) in tagList" :key="index">{{item.name}}</div>
            </div>
        </div>
        <div class="btn" @click="commitBespeakTag">提交</div>
        <div class="tipBox" v-if="tipStatus">
            <div class="tip">{{tip}}</div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                typeList:[
                    {
                        name:'正常',
                        status:0
                    },{
                        name:'轻度',
                        status: 1
                    },{
                        name:'中度',
                        status: 2
                    },{
                        name:'重度',
                        status: 3
                    },
                ],
                tagLevel:0,
                tagList:[],
                bespeakId:'',
                companyId:'',
                score:'',
                tipStatus:false
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        watch:{
            score(){
               if(this.score<0){
                   this.score = ''
               }else if(this.score>100){
                   this.score = 100
               }
            }
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isStatus(v){
                let arr = ['预约中','待咨询','进行中','已完成','已取消']
                return arr[v]
            },

            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            }
        },
        computed: {},
        methods: {
            changeScore(e){
                console.log(e)
            },
            setTagText(i){
                this.tagList[i].status = !this.tagList[i].status
            },
            change(n){
                this.tagLevel=n
            },
            isSureTo(){
                this.to(`record?bespeakId=${this.bespeakId}`)
            },
            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            },
            startUserBespeakSure(bespeakId,time,name){
                this.bespeakId=bespeakId;
                this.time= time
                this.name= this.isServeType(name)
                this.maskStatus2=true;
            },
            async getBespeakTagList() {
                let data = await getSources("/bear-scale/api/scaleUserBespeakTag/getBespeakTagList",{
                    companyId:this.companyId
                });
                if (data.status === 0) {
                    let arr = data.tagList
                    arr.forEach(v=>{
                        this.tagList.push({
                            name:v,
                            status:false
                        })
                    })
                    this.getBespeakTagRecord()
                }else{
                    this.showTip(data.msg)
                }
            },
            async getBespeakTagRecord() {
                let data = await getSources("/bear-scale/api/scaleUserBespeakTag/getBespeakTagRecord",{
                    bespeakId:this.bespeakId
                });
                if (data.status === 0) {
                    this.score=data.bespeakTag.score,
                    this.tagLevel = data.bespeakTag.tagLevel

                    let arr = JSON.parse(data.bespeakTag.tagText)
                    this.tagList.forEach(v=>{
                        arr.forEach(item=>{
                            if(v.name==item){
                                v.status =true
                            }
                        })

                    })
                }else{
                    this.showTip(data.msg)
                }
            },
            async commitBespeakTag() {
                let arr=[];
                this.tagList.forEach(v=>{
                    if(v.status){
                        arr.push(v.name)
                    }
                })
                let data = await getSources("/bear-scale/api/scaleUserBespeakTag/commitBespeakTag",{
                    bespeakId:this.bespeakId,
                    tagLevel:this.tagLevel,
                    score:this.score,
                    tagText:JSON.stringify(arr)
                });
                if (data.status === 0) {
                    this.to(`record?bespeakId=${this.bespeakId}`)
                }else{
                    this.showTip(data.msg)
                }
            },
            showTip(v){
                this.tip=v;
                this.tipStatus=true;
                setTimeout(()=>{
                    this.tipStatus=false;
                },1500)
            },
            to(n){
                this.$router.push(n)
            },



        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            this.companyId=localStorage.getItem('companyId')?localStorage.getItem('companyId'):'',
            this.bespeakId = this.$route.query.bespeakId
            this.getBespeakTagList()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/label.vue